import { z } from "zod";

export const FsmTranslationsSchema = z.object({
  en: z.string().min(1).optional(),
  es: z.string().min(1).optional(),
});

export type FsmTranslations = z.infer<typeof FsmTranslationsSchema>;

const brandedId = <T extends string>(_brand: T) => z.string().uuid().brand<T>();

export const CustomerId = brandedId("CustomerId");
export const DocumentTypeId = brandedId("DocumentTypeId");
export const StateId = brandedId("StateId");
export const TransitionId = brandedId("TransitionId");
export const EntityTypeId = brandedId("EntityTypeId");
export const EntityId = brandedId("EntityId");
export const DocumentId = brandedId("DocumentId");
export const TransitionLogId = brandedId("TransitionLogId");
export const FieldDefinitionId = brandedId("FieldDefinitionId");
export const AttachmentId = brandedId("AttachmentId");
export const MaterialId = brandedId("MaterialId");
export const MaterialRequestLineId = brandedId("MaterialRequestLineId");

export type CustomerId = z.infer<typeof CustomerId>;
export type DocumentTypeId = z.infer<typeof DocumentTypeId>;
export type StateId = z.infer<typeof StateId>;
export type TransitionId = z.infer<typeof TransitionId>;
export type EntityTypeId = z.infer<typeof EntityTypeId>;
export type EntityId = z.infer<typeof EntityId>;
export type DocumentId = z.infer<typeof DocumentId>;
export type TransitionLogId = z.infer<typeof TransitionLogId>;
export type FieldDefinitionId = z.infer<typeof FieldDefinitionId>;
export type AttachmentId = z.infer<typeof AttachmentId>;
export type MaterialId = z.infer<typeof MaterialId>;
export type MaterialRequestLineId = z.infer<typeof MaterialRequestLineId>;
